import store from './store';

const toBoolean = (x) => !!x;

export const setIsLoading = store.create.set('isLoading', toBoolean);
